import React  from "react";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../providers/TranslationProvider";
import DefaultHeading from "../../components/heading/DefaultHeading";
import { geoFencingOption } from "./updateGeofenceTypes";
import { Autocomplete, TextField } from "@mui/material";
import Attendance from "../../components/updateGeofence/attendance/Attendance";
import DbAndOutlet from "../../components/updateGeofence/dbAndOutlet/DbAndOutlet";
import {   getGeoFencingOptions } from "./updateGeofenceService";
import "./updateGeofence.css"
const UpdateGeofence = () => {
  const { translate } = usePortalTranslation();
  const [geoFencing, setGeoFencing] = React.useState<geoFencingOption | null>(
    null
  );
  const geoFencingOptions: geoFencingOption[] = getGeoFencingOptions();


  return (
   <div className="updateGeofence-wrapper">
        <DefaultHeading
          heading={translate(TranslationEnum.geofence, "Add Geofence Distance")}
          showDefaultBackButton={true}
        />
        <Autocomplete
          sx={{ width: "100%" }}
          value={geoFencing} // Keep the value as the geoFencing object
          onChange={(event, value: geoFencingOption | null) => {
            setGeoFencing(value); // Set the selected object
          }}
          options={geoFencingOptions}
          getOptionLabel={(option: geoFencingOption) =>
            translate(TranslationEnum.geofence, option.label)
          } // Display the option label using translation
          renderInput={(params: any) => (
            <TextField
              {...params}
              label={translate(TranslationEnum.geofence, "Select Geo Fencing")}
            />
          )}
        />

        {geoFencing &&
          geoFencing.id === "attendance" && ( // Check if the selected option is "attendance"
            <Attendance 
            />
          )}

        {geoFencing &&
          geoFencing.id === "dbAndOutlet" && ( // Check if the selected option is "db"
            <DbAndOutlet />
          )}

          
      </div>
  );
};

export default UpdateGeofence;
